var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" 投注站购买实战超市方案 ")])
}
var staticRenderFns = []

export { render, staticRenderFns }